import { useState } from 'react';
import { motion } from 'motion/react';
import { snappyTween } from './motionUi';

const MAX_LEN = 64;

export default function GamePlayerIdModal({ initialPlayerId = '', onSubmit, busy = false }) {
  const [value, setValue] = useState(initialPlayerId);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (trimmed.length < 1) {
      setError('Enter your player ID.');
      return;
    }
    if (trimmed.length > MAX_LEN) {
      setError(`Max ${MAX_LEN} characters.`);
      return;
    }
    setError('');
    onSubmit?.(trimmed);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="space-y-4 p-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div>
        <label
          htmlFor="game-player-id"
          className="mb-1.5 block text-[10px] font-semibold uppercase tracking-wide text-game-muted"
        >
          Player ID
        </label>
        <motion.input
          id="game-player-id"
          type="text"
          value={value}
          maxLength={MAX_LEN}
          disabled={busy}
          onChange={(e) => {
            setValue(e.target.value);
            setError('');
          }}
          className="w-full rounded-xl border border-white/15 bg-game-surface px-3 py-2.5 text-sm text-game-text placeholder:text-game-muted focus:border-game-accent/50 focus:outline-none focus:ring-1 focus:ring-game-accent/40 disabled:opacity-50"
          placeholder="Your save slot id"
          autoComplete="username"
          whileFocus={{ scale: busy ? 1 : 1.01 }}
          transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        />
        <p className="mt-1 text-right text-[10px] text-game-muted">
          {value.length}/{MAX_LEN}
        </p>
        {error ? <p className="mt-1 text-xs text-red-400">{error}</p> : null}
      </div>
      <motion.button
        type="submit"
        disabled={busy}
        transition={snappyTween}
        whileHover={{ scale: busy ? 1 : 1.02 }}
        whileTap={{ scale: busy ? 1 : 0.98 }}
        className="w-full rounded-xl bg-game-accent py-2.5 text-sm font-bold text-game-accentText disabled:opacity-50"
      >
        {busy ? 'Please wait…' : 'Continue'}
      </motion.button>
    </motion.form>
  );
}
